import React from 'react'
import styles from './ListCard.module.css'

interface ListCardProps {
  children: React.ReactNode
  icon?: React.ReactNode
  onClick?: () => void
}

const ListCard: React.FC<ListCardProps> = ({ children, icon, onClick }) => {
  return (
    <li className={styles.listCard} onClick={onClick}>
      {icon && <div className={styles.icon}>{icon}</div>}
      <div className={styles.content}>{children}</div>
    </li>
  )
}

export default ListCard
